import * as Yup from 'yup';
import { useFormik } from 'formik';

import { EMAIL_INVALID, requiredMsg } from 'lib/constants/messages';

const InviteOwnerSchema = Yup.object().shape({
  f_name: Yup.string().required(requiredMsg('First name')),
  l_name: Yup.string().required(requiredMsg('Last name')),
  email: Yup.string().email(EMAIL_INVALID).required(requiredMsg('Email'))
});

export default function useInviteOwnerFormik(onSubmit) {
  const formik = useFormik({
    initialValues: { f_name: '', l_name: '', dob: '', gender: '', email: '', phone: '' },
    validationSchema: InviteOwnerSchema,
    onSubmit
  });

  return formik;
}
